import React, { useState, useEffect } from "react"
import { startRecording, stopRecording } from "../../audio";
import { useLocation } from "react-router-dom";
import { getFromApi } from "../../helpers/api";
import Hero from "./Hero";
import Minting from "./Minting";
import { useConnect, useAccount } from 'wagmi';
import FailureModal from "./FailureModal";

const Listen = () => {
  let location = useLocation();
  const { address, connector, isConnected } = useAccount();
  const [recording, setRecording] = useState(false);
  const [response, setResponse] = useState();
  const [info, setInfo] = useState("");
  const [artistName, setArtistName] = useState("");
  const [loading, setLoading] = useState(true);
  const { connect, connectors, error, isLoading, pendingConnector } = useConnect();
  useEffect(() => {
    const artist = location.pathname.split("/")[1];
    if (artist) {
      setArtistName(artist);
      loadArtist(artist);
    }
  }, [location]);

  const loadArtist = async (artist) => {
    const result = await getFromApi(`artist?name=${artist.split("@")[1]}`);    
    setInfo(result);
    setLoading(false);
  };
  return (
    <div>
      {loading ? 
        <h1 className="font-serif">Fetching info for {artistName}...</h1>
       : response?.success ?
       <Minting info={info}/> :       
        <div>
          <Hero
            connect={connect}
            connectors={connectors}
            error={error}
            isLoading={isLoading}
            pendingConnector={pendingConnector}
            isConnected={isConnected}
            info={info}
            recording={recording}
            startRecording={startRecording}
            stopRecording={stopRecording}
            setRecording={setRecording}
            setResponse={setResponse}
            response={response}
          />
          {response?.success === false && <FailureModal setResponse={setResponse} />}
        </div>
      }
    </div>
  );
};

export default Listen;
